'use client'

// for development environment purpose or production localhost
export const msvcProxy = (variable: string): string => {
  const isDevelopment = process.env.NODE_ENV === 'development'
  const isProductionLocalhost =
    process.env.NODE_ENV === 'production' && typeof window !== 'undefined' && window.location.hostname === 'localhost'

  return isDevelopment || isProductionLocalhost ? '/b2b' : variable
}
